import { useState, useEffect } from 'react';

import { WorkflowStepDto } from 'src/@types/workflow/types';
import { getWorkflowDefinition } from 'src/services/workflow/workflowDefinitionService';

export default function useOverridableWorkflowSteps(definitionNumber: number | '') {
  const [overridableSteps, setOverridableSteps] = useState<WorkflowStepDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoadFailed, setHasLoadFailed] = useState(false);

  useEffect(() => {
    if (definitionNumber === '') {
      setOverridableSteps([]);
      setHasLoadFailed(false);

      return undefined;
    }

    let isCurrent = true;
    setIsLoading(true);
    setHasLoadFailed(false);

    getWorkflowDefinition(definitionNumber)
      .then((definition) => {
        if (!isCurrent) {
          return;
        }

        setOverridableSteps((definition.steps ?? []).filter((step) => step.isAssigneeOverridable));
      })
      .catch(() => {
        if (isCurrent) {
          setOverridableSteps([]);
          setHasLoadFailed(true);
        }
      })
      .finally(() => {
        if (isCurrent) {
          setIsLoading(false);
        }
      });

    return () => {
      isCurrent = false;
    };
  }, [definitionNumber]);

  return {
    overridableSteps,
    isLoadingOverridableSteps: isLoading,
    hasOverridableStepsLoadFailed: hasLoadFailed,
  };
}
